import React from 'react';
import styled from 'styled-components';

interface ChallengeIndicatorProps {
  active: boolean;
  mode: string;
  goal?: string;
  points?: number;
  progress?: number;
  maxProgress?: number;
}

const ChallengeContainer = styled.div<{ $active: boolean }>`
  background: ${props => props.$active ? 'linear-gradient(135deg, #4caf50, #2196f3)' : 'linear-gradient(135deg, rgba(255,255,255,0.12), rgba(255,255,255,0.05))'};
  color: #fff;
  padding: 12px 16px;
  border-radius: 14px;
  margin: 12px 0;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  border: 1px solid rgba(255,255,255,0.25);
  position: relative;
  overflow: hidden;
`;

const ChallengeHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const ChallengeTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ChallengeValue = styled.div`
  font-weight: 700;
  font-size: 18px;
`;

const ChallengeDescription = styled.div`
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 10px;
`;

const ChallengeProgress = styled.div<{ $progress: number; $active: boolean }>`
  height: 6px;
  background: rgba(255,255,255,0.2);
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: ${props => props.$progress}%;
    background: ${props => props.$active ? '#4caf50' : 'rgba(255,255,255,0.5)'};
    transition: width 0.5s ease;
  }
`;

const ChallengeIndicator: React.FC<ChallengeIndicatorProps> = ({ 
  active, 
  mode, 
  goal = 'Uppnå målet', 
  points = 25,
  progress = 0,
  maxProgress = 100 
}) => {
  const progressPercent = Math.min(100, Math.max(0, (progress / maxProgress) * 100));
  
  return (
    <ChallengeContainer $active={active}>
      <ChallengeHeader>
        <ChallengeTitle>
          <span role="img" aria-label="Challenge">🎯</span> Utmaning
        </ChallengeTitle>
        <ChallengeValue>+{points}p</ChallengeValue>
      </ChallengeHeader>
      <ChallengeDescription>
        {goal}
      </ChallengeDescription>
      <ChallengeProgress $progress={progressPercent} $active={active} />
    </ChallengeContainer>
  );
};

export default ChallengeIndicator;